import React from 'react'
import { renderModifiedGroup, renderRegularOrgRateEntry } from '../AllOrgActivities/formHelper';
import { groupDifferencesByAction } from '../AllOrgActivities/helper';
import { Col, Row, Card } from 'antd';

export const OrgDriverRates = ({data}) => {
   const renderEntireGroup = (changes, title, type) => {
    if (!changes?.length) return null;
    return(
      <div>
      <h4
        className="ant-typography ant-typography-md font-medium mb-3"
        style={{ textAlign: "left", fontSize: "16px" }}
      >
        {title}
      </h4>
      <Card
      style={{
        background: '#fff',
        borderRadius: '8px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.09)',
      }}
      >
        {renderRegularOrgRateEntry(changes, title, type)}
      </Card>
      </div>
    )
  }

  const renderDetails = () => {
    const  orgDriverRateSheetData = data?.difference[0]?.ratesheet_details ?? [];
    const incomingAction = data?.difference[0]?.ratesheet_details?.[0]?.action;  
    const groupedDifferences = groupDifferencesByAction({ action: incomingAction, difference:  orgDriverRateSheetData });
    const incomingEntry =  orgDriverRateSheetData[0]?.new_value ? "New Entry" : "Old Entry";
    return (
      <div className="mt-6">
          <h4 className="ant-typography ant-typography-md font-medium mb-3" style={{ textAlign: 'left', fontSize: '18px' }}>
              <span style={{ fontSize: '20px', color: '#395484' }}>Driver Rate Sheet Details</span>
              <div className="mt-6">
                  {renderEntireGroup(groupedDifferences.REMOVED, incomingEntry, 'REMOVED')}
                  {renderEntireGroup(groupedDifferences.ADDED, incomingEntry, 'ADDED')}
                  {renderModifiedGroup(groupedDifferences.MODIFIED,[], "ratesheet")}
              </div>
          </h4>
      </div>
  );
  }

  return (
    <Row gutter={[16, 32]}>
      <Col span={24}>{renderDetails()}</Col>
    </Row>
  )
}